<template>
  <div class="block" style="height: 405px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="原密码" prop="oldPwd">
        <el-input v-model="form.oldPwd" :type="'password'">
          <!-- isPwd -->
        </el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" :type="'password'"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="rePassword">
        <el-input v-model="form.rePassword" :type="'password'"></el-input>
      </el-form-item>
      <el-form-item>
        <!-- <el-checkbox v-model="isShow">显示原密码</el-checkbox> -->
        <el-button type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updatePwd } from "@/api/user";
export default {
  data() {
    return {
      // isShow: false,
      form: {
        oldPwd: "",
        password: "",
        rePassword: ""
      },
      rules: {
        oldPwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        rePassword: [{ required: true, message: "请确认密码", trigger: "blur" }]
      }
    };
  },
  computed: {
    // isPwd() {
    //   if (this.isShow) {
    //     return "text"
    //   } else {
    //     return "password"
    //   }
    // }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          updatePwd(this.form).then(res => {
          // console.log(res);
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.form = {};
        });
        } else {
          // alert("校验失败")
          console.log("校验失败");
          return false;
        }
      });
    },
    cancel() {
      this.form = {};
    }
  }
};
</script>
